import * as React from 'react';
import styled from 'styled-components';
import { Grid, GridProps } from 'react-flexbox-grid';

const StyledGrid = styled(Grid)<GridProps>`
  padding-left: ${props => `${props.theme.gridGutter}px !important` || '8px'};
  padding-right: ${props => `${props.theme.gridGutter}px !important` || '8px'};
`;

export default (props: any) => <StyledGrid {...props}>{props.children}</StyledGrid>;



// WEBPACK FOOTER //
// ./src/components/primitives/Grid.tsx